import { NextPage } from "next";
import { getGlobals } from "@models/globals.model";
import { getProductGlobals, ProductGlobalSchema } from "@models/product-globals.model";
import { AccountGlobalSchema, getUserAccountGlobals } from "@models/user-account-globals";
import { Sanity } from "@models/sanity.model";
import AccountAuth from "@components/account-auth";

interface PaymentsPageProps extends Sanity.PageProps {
  productGlobals: ProductGlobalSchema;
  accountGlobals: AccountGlobalSchema;
}

const PaymentsPage: NextPage<PaymentsPageProps> = ({ globals, productGlobals, accountGlobals }) => {
  const { membership_modal } = productGlobals;

  return (
    <AccountAuth
      globals={globals}
      accountGlobals={accountGlobals}
      pageID="payment-history"
      seo={{ title: "Account | Payment History" }}
      membershipModal={membership_modal}
    />
  );
};

export default PaymentsPage;

export async function getStaticProps() {
  const [globals, productGlobals, accountGlobals] = await Promise.all([
    await getGlobals(),
    await getProductGlobals(),
    await getUserAccountGlobals(),
  ]);
  return {
    props: {
      globals,
      productGlobals,
      accountGlobals,
    },
  };
}
